import { GzSingleSelectListPhoneCodeWebComponent } from './component/GzSingleSelectListPhoneCodeWebComponent';

export { GzSingleSelectListPhoneCodeWebComponent };
